import React from 'react';
import { Provider } from 'react-redux';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from 'Douleutaras/app/app';
import { PostHogProvider } from 'posthog-js/react';
import { posthogConfig } from 'Douleutaras/app/lib/posthog/posthog.config';
import PusherContext from 'Douleutaras/app/PusherContext';

export const Client = ({ store: injectedStore, pusherChannel }) => (
  <PusherContext.Provider value={pusherChannel}>
    <Provider store={injectedStore}>
      <Router>
        <PostHogProvider {...posthogConfig}>
          <App />
        </PostHogProvider>
      </Router>
    </Provider>
  </PusherContext.Provider>
);

export function createRender(container, store, pusherChannel): void {
  if (container.hasChildNodes()) {
    hydrateRoot(container, <Client store={store} pusherChannel={pusherChannel} />);
  } else {
    createRoot(container).render(<Client store={store} pusherChannel={pusherChannel} />);
  }
}
